<template>
    <div class="view-wrapper">
        <div class="text-wrapper">
            <h2>GDPR compliance</h2>
            <h3>What data is collected?</h3>
            <p>
                We, FITCS webdevelopment (on behalf of Amsterdam UMC), only collect data that you have personally entered in the survey.
                Your IP-address may be logged for diagnostic purposes, and will subsequently be removed within 1 week of page access.
            </p>
            <h3>Why do we collect data?</h3>
            <p>
                We collect the survey information only to register you as an attendee of the 'Amsterdam UMC CCA retreat'.
                For this goal, we require identifying information such as your name.
                We also require information about your attendance to meetings, socials and overnight stay in order to approximate
                the amount of attendees, or to make arrangements for you.
            </p>
            <h3>How will my data be used?</h3>
            <p>
                Your data will be shared with <a href="https://www.amsterdamumc.nl/">Amsterdam UMC</a> in order to register you.
                As Amsterdam UMC is the event host, they require your information to make arrangements for the CCA retreat.
            </p>
            <h3>How long will my data be kept?</h3>
            <p>
                Your data will be removed no more than 24 months after the CCA retreat. This includes data shared with Amsterdam UMC.
                Amsterdam UMC will use this data to prepare and improve the next annual retreat.
            </p>
            <h3>Is my data stored securely?</h3>
            <p>
                Your data is safely stored in a password-protected database that is not publicely accessible.
                The database itself is hosted on a VPS, access is regualted by public/private key cryptography.
                Any data sent over the internet while submitting the form is protected by SSL, provided by letsencrypt.
            </p>
            <h3>Respondent rights</h3>
            <p>
                All contact is performed though Amsterdam UMC, email address <a href="mailto:contact@cancercenteramsterdam.nl">contact@cancercenteramsterdam.nl</a>.
                If you wish to remove or alter your submission data, please contact Amsterdam UMC through this email address.
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'v-gdpr'
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .view-wrapper{
        padding-bottom:200px;
        max-width:800px;
        margin:0 auto;
        overflow:hidden;
        @media(max-width:1000px){
            max-width:500px;
        }
        @media(max-width:700px){
            max-width:300px;
        }
        @media(max-width:500px){
            max-width:100%;
        }
    }
    .text-wrapper{
        h1{
            font-size:1.25em;
        }
        img{
            max-width:100%;
            margin:0 auto;
        }
        .img-center{
            text-align:center;
        }
        .warning-text{
            //text-align:center;
            font-size:1.15em;
            .red{
                color:#f90202;
                a{
                    color:#f90202;
                }
            }
        }
        font-size:1.15em;
    }
</style>
